/* global jQuery */
import LiveShoppingSlide from './widgets/live-shopping-widget';
import TaggedLogger from './debug/tagged-logger';

(($) => {
  const logger = new TaggedLogger('Liveshopping widget', '');
  /**
   * Shopgate live shopping widget.
   * @param {Object} opts Options.
   * @return {*}
   */
  $.fn.shopgateLiveshopping = function (opts = {}) {
    const options = {
      updateInterval: 1000,
      swiper: {},
      ...opts,
    };
    const $parent = $(this).closest('.sg-widget-row');

    const onHide = function () {
      let slidesCount;
      if (options.swiper.removeSlide) {
        options.swiper.removeSlide($(this).index());
        options.swiper.swipeTo(0);
        slidesCount = options.swiper.slides.length;
      } else {
        $(this).remove();
        slidesCount = $parent.find('.swiper-slide').length;
      }

      if (slidesCount === 0) {
        logger.info('Hiding liveshopping widget');
        $parent.hide();
      }
    };

    return this.each((key, element) => {
      $(this).data('slide-key', key);
      const slide = new LiveShoppingSlide($, $(element), logger, options);
      slide.$container.on(slide.constructor.events.LIVE_SHOPPING_SLIDE_HIDE, onHide);
      slide.start();
    });
  };
})(jQuery);




// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-liveshopping.js